import React from 'react';
import { styles } from './QuickSearch.css';
import { SearchIcon } from '@jbhi-fi/lanyard-ui/components/Icons/Search';

export const QuickSearch = () => {
  return (
    <div className={styles.container}>
      <div id="quicksearch-search-box">
        <SearchIcon className={styles.icon} />
        <input placeholder="Search products, brands, and more..." className={styles.searchInput} />
      </div>
    </div>
  );
};
